import Vue from "vue";
import { Toast } from "vant";

function ready(callback) {
  // 如果 jsbridge 已经注入则直接调用
  if (window.AlipayJSBridge) {
    callback && callback();
  } else {
    // 如果没有注入则监听注入的事件
    document.addEventListener("AlipayJSBridgeReady", callback, false);
  }
}

let config = {
  baseUrl: "",
  headers: {
    //"Content-Type": "application/json",
	"Content-Type": "application/x-www-form-urlencoded",	
	'api-serviceId': '1526494863636434944',
	'api-appid': '1514893127704514560',
  }
};

/**
 * request
 * @param {*} url 接口url
 * @param {*} type get/post
 * @param {*} params 不传的话,默认为空{}
 */
export function request({ url, headers = {}, type = "put", params = {} }) {
  return new Promise((res, rej) => {
    ready(() => {
      window.AlipayJSBridge.call(
        "xyrequest",
        {
          url: config.baseUrl + url,
          type,
          data: params,
          headers: { ...config.headers, ...headers }
        },
        function(data) {
          console.log("request - data11", data);
          // native return {data code msg}
          if (!isEmpty(data.data)) {
            return res(JSON.parse(data.data));
          } else {
            // 网络错误信息
            // Toast.fail(data.msg)
            return rej(data.msg);
          }
        }
      );
    });
  });
}

function isEmpty(obj) {
  if (Object.keys(obj).length === 0) {
    return true;
  }
  return false;
}
